import React, { memo } from "react";
import PropTypes from "prop-types";

export const RenderUnattendedRelief = memo(({ value }) => {
  return value === "Y" ? (
    <div
      style={{
        fontWeight: "bold",
        fontSize: "1.25em",
        border: "4px solid black",
        borderRadius: "20px",
        padding: "2px 2px",
      }}
    >
      Y
    </div>
  ) : (
    <div>N</div>
  );
});

RenderUnattendedRelief.displayName = "RenderUnattendedRelief";

RenderUnattendedRelief.propTypes = {
  value: PropTypes.string,
};
